import { Injectable, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class I18nMatPaginatorIntl extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
    this.translateLabels();
    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 - 0 of ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} of ${length}`;
  };

  private translateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('masterTable.paginator.itemsPerPage');
    this.nextPageLabel = this.translate.instant('masterTable.paginator.nextPage');
    this.previousPageLabel = this.translate.instant('masterTable.paginator.previousPage');
    this.firstPageLabel = this.translate.instant('masterTable.paginator.firstPage');
    this.lastPageLabel = this.translate.instant('masterTable.paginator.lastPage');
  }
}
